import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
  AfterSaleCreateFormFlowStyles,
  AfterSaleCreateFormStyles,
} from '../../common/AfterSale/AfterSaleCreate.styles';
import { CenteredDivTitle } from '../../common/components/CenteredPageTitle.styles';
import { addNewAccident } from '../../features/accidents/accidentsActions';
import { FormInputText } from '../../common/formInputs/FormInputText';

const schema = yup.object({
  customer_number: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci numero di telefono!')
    .matches(
      /^[3]{1}[0-9]{8,9}$/,
      'Il numero non e corretto',
    ),
});

function CreateAccident(location) {
  const { quoteId } = useParams();
  const navigate = useNavigate();

  const isOpenedByCommand = location.state !== undefined
    && location.state?.type === 'command'
    && location.state.data?.page === 'accident';
  const {
    register, formState: { errors, touchedFields }, trigger, watch,
  } = useForm({
    mode: 'all',
    resolver: yupResolver(schema),
    shouldFocusError: true,
    values: {
      customer_number: isOpenedByCommand ? location.state.data?.customer_number ?? '' : '',
    },
  });

  const answers = watch();

  const submitData = async (formData) => {
    const triggerValidation = await trigger(['customer_number']);
    if (!triggerValidation) {
      return;
    }

    addNewAccident(quoteId, formData, navigate);
  };

  const isValid = (name) => {
    if (errors[name]?.message !== undefined) {
      return false;
    }

    if (touchedFields[name] === undefined) {
      return false;
    }
    return true;
  };

  return (
    <AfterSaleCreateFormFlowStyles>
      <AfterSaleCreateFormStyles>
        <CenteredDivTitle className="d-flex align-items-center justify-content-center gap-3 mt-3">
          <div className="after-sale-title divider">
            <h2 className="text-center">Completa i dati Sinistro</h2>
          </div>

        </CenteredDivTitle>

        <div className="form-container-after-sale">
          <FormInputText
            registration={register('customer_number')}
            label="Phone"
            paragraph="Numero di telefono del cliente"
            error={errors.customer_number?.message}
            valid={isValid('customer_number')}
          />
        </div>
        <div className="mt-3">
          <div className="d-flex justify-content-between">
            <button
              className="btn btn-questionnaire "
              onClick={() => submitData(answers)}
            >
              Continua
            </button>
          </div>
        </div>
      </AfterSaleCreateFormStyles>
    </AfterSaleCreateFormFlowStyles>
  );
}

export default CreateAccident;
